if (!customElements.get('wb-product-information')) {
  customElements.define('wb-product-information', class extends HTMLElement {
    connectedCallback() {
      this.openDescription = () => {
        const panel = this.querySelector('[data-info="description"]');
        if (panel) panel.open = true;
      };
      this.openDescription();
      window.addEventListener('pageshow', this.openDescription);
      if (this.ready) return;
      this.ready = true;
      const description = this.querySelector('[data-description]');
      const about = this.querySelector('[data-about]');
      const details = this.querySelector('[data-details]');
      const size = this.querySelector('[data-size]');
      const reveal = (node) => { node.closest('details').hidden = false; };
      if (description && !about.textContent.trim()) {
        description.querySelectorAll('p').forEach(p => {
          const lines = p.innerHTML.split(/<br\s*\/?\s*>/i);
          if (lines.length > 1 && /^(details|features|about this item|highlights)\s*: ?$/i.test(lines[0].replace(/<[^>]*>/g, '').trim().replace(/:$/, '') + ': ')) {
            const ul = document.createElement('ul');
            lines.slice(1).forEach(line => {
              const li = document.createElement('li');
              li.innerHTML = line.replace(/^\s*(?:\?|•|–|-)\s*/, '');
              if (li.textContent.trim()) ul.append(li);
            });
            if (ul.children.length) { about.append(ul); p.remove(); }
          }
        });
        description.querySelectorAll('h2,h3,h4').forEach(heading => {
          const title = heading.textContent.trim();
          if (/^(product details|details|specifications|materials.*)$/i.test(title) && !details.textContent.trim()) {
            let next = heading.nextElementSibling;
            while (next && !/^H[1-6]$/.test(next.tagName)) {
              const following = next.nextElementSibling;
              details.append(next); next = following;
            }
            heading.remove();
            if (details.textContent.trim()) reveal(details);
          } else if (/^(about this item|features|highlights)$/i.test(title)) heading.remove();
        });
        description.querySelectorAll('ul,ol').forEach(list => {
          if (!/^available options$/i.test(list.previousElementSibling?.textContent.trim() || '')) about.append(list);
        });
        if (about.textContent.trim()) reveal(about);
      }
      if (!about.textContent.trim() && details.querySelector('li')) {
        const ul = document.createElement('ul');
        details.querySelectorAll('li').forEach(li => {
          if (!/^(?:.*(?:shell|lining)|\d+%|professional|hand wash|machine wash|material|fabric|care)/i.test(li.textContent.trim())) ul.append(li);
        });
        if (ul.children.length) { about.append(ul); reveal(about); }
      }
      if (!details.textContent.trim()) {
        const facts = Array.from(about.querySelectorAll('li')).filter(li => /\b(polyester|cotton|wool|cashmere|nylon|acrylic|leather|spandex|elastane|material|fabric|silicone|stainless|care|wash|dimensions|capacity|voltage|power supply)\b/i.test(li.textContent));
        if (facts.length) {
          const ul = document.createElement('ul');
          facts.forEach(li => ul.append(li));
          details.append(ul); reveal(details);
        }
      }
      description?.querySelectorAll('table').forEach(table => {
        if (/\b(size|chest|bust|waist|inseam|shoulder)\b/i.test(table.textContent)) { size.prepend(table); reveal(size); }
      });
      const connectChart = () => {
        const trigger = document.querySelector('button.scr-open-size-chart');
        if (!trigger) return false;
        const button = this.querySelector('[data-chart-trigger]');
        button.hidden = false;
        button.onclick = () => trigger.click();
        reveal(size);
        return true;
      };
      if (!connectChart()) {
        this.observer = new MutationObserver(() => { if (connectChart()) this.observer.disconnect(); });
        this.observer.observe(document.body, {childList:true,subtree:true});
        this.timer = setTimeout(() => this.observer.disconnect(), 20000);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); clearTimeout(this.timer); window.removeEventListener('pageshow', this.openDescription); }
  });
}
